<template>
    <div
            class="action--card mbs-1 cursor--pointer"
            @click="manageAction()"
            :id="`action-card-${uid}`"
    >
        <i
                class="action--card-icon"
                :class="action.icon"
        />
        <p
                class="action--card-text"
        >
            {{action.title}}
        </p>
        <b-btn
                class="action--card-btn"
        >
            {{action.actionTexte}}
        </b-btn>
        <!-- Account profile picture -->
        <b-form-file
                class="d-none"
                ref="avatarFile"
                v-model="form.avatar"
                @input="accountAddPhoto()"
        />
    </div>
</template>
<script>
    import basicErrorHandler from '@/utils/handlers/basicErrorHandler'
    import apiResponseHandler from '@/utils/handlers/apiResponseHandler'

    const updateAvatarErrors = {
        200: ['Avatar changé', 'Votre image de profil a été modifiée.', 'success'],
        400: ['Avatar trop lourd', 'Le poids maximal autorisé pour votre avatar est de 2Mb', 'error'],
        500: ['Avatar trop lourd', 'Le poids maximal autorisé pour votre avatar est de 2Mb', 'error'],
    }

    export default {
        name: 'home-top-worker',
        props: {
            action: Object
        },
        mounted() {
            this.uid = this._uid
        },
        data: () => ({
            uid: null,
            form: {
                avatar: null
            }
        }),
        methods: {
            manageAction() {
                if (this.action.actionType === 'route') {
                    this.$router.push(this.action.actionParams)
                }
                switch (this.action.actionParams.name) {
                    case 'friend_add':
                        this.addFriend()
                        break
                    case 'meeting_register':
                        this.meetingRegister()
                        break
                    case 'account_photo':
                        this.$refs.avatarFile.$el.querySelector('input').click()
                        break
                }
            },
            async addFriend() {
                await this.$store.dispatch('base/friend/add', {userId: this.action.actionParams.params.id})
                this.remove()
            },
            async meetingRegister() {
                await this.$store.dispatch('base/meeting/reservation/create', {
                    meetingId: this.action.actionParams.params.id
                })
                this.remove()
            },
            async accountAddPhoto() {
                try {
                    const {avatar} = this.form
                    const {status} = await this.$store.dispatch('base/account/avatar', {avatar})
                    apiResponseHandler(status, null, updateAvatarErrors)
                    if (status === 200) this.remove()
                } catch (e) {
                    basicErrorHandler(e)
                }
            },
            remove() {
                this.$destroy();
                this.$el.parentNode.removeChild(this.$el);
            }
        }
    }
</script>
